import React from "react";
import style from "./index.module.css";

const Input = ({ value = "", label = "", placeholder = "", ...props }) => (
  <div className={style.inputBox}>
    {label && <label htmlFor="">{label}</label>}
    <input
      style={{ outline: "none", border: "none" }}
      value={value}
      {...props}
      placeholder={label ? "" : placeholder}
    />
  </div>
);

export default Input;
